<template>
  <div class="answerDetail">
    <div v-if="chartData.length > 0">
      <van-tabs
        v-model="menuState"
        @change="stateChanged"
        title-active-color="#009ed4"
        color="#009ed4"
        :ellipsis="false"
      >
        <van-tab
          v-for="(menu, index) in menuList"
          :key="index"
          :title="menu.title"
          :name="menu.name"
        >
          <div v-if="menuState == 1 && chartData[0]">
            <zm-tree-org
              ref="tree1"
              center
              :data="chartData[0]"
              @on-node-click="onCopy"
            ></zm-tree-org>
          </div>
          <div v-if="menuState == 2 && chartData[1]">
            <zm-tree-org
              ref="tree2"
              center
              :data="chartData[1]"
              @on-node-click="onCopy"
            ></zm-tree-org>
          </div>
          <div v-if="menuState == 3 && chartData[2]">
            <zm-tree-org
              ref="tree3"
              center
              :data="chartData[2]"
              @on-node-click="onCopy"
            ></zm-tree-org>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";
Vue.use(Tab).use(Tabs);

export default {
  name: "answerDetail",
  data() {
    return {
      SIRId: "",
      chartData: [],
      menuState: 1,
      menuList: [],
    };
  },
  created() {
    const { SIRId } = this.$route.query;
    if (SIRId) {
      this.SIRId = SIRId;
      this.getSupplierQuestionnaireAnswerListBySIRId();
    }
  },
  methods: {
    getMenuList(data) {
      for (var idx in data) {
        if (this.chartData[idx].label) {
          this.menuList.push({
            title: this.chartData[idx].label,
            name: parseInt(idx) + 1,
          });
        }
      }
    },
    stateChanged(state) {
      this.menuState = state;
    },
    onCopy(e, data) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: data.label,
        alertText: this.$t.meta.copySuccess,
      });
    },
    getSupplierQuestionnaireAnswerListBySIRId() {
      this.$commonMethod.showLoading();
      var param = {
        SIRId: this.SIRId,
      };
      this.$api.supplier
        .getSupplierQuestionnaireAnswerListBySIRId(param)
        .then((res) => {
          var data = res.data;
          var formatData = (item) => {
            item.children = [];
            item.label = item.ProblemText;
            if (item.ChildProblemList && item.ChildProblemList.length > 0) {
              item.children = item.children.concat(item.ChildProblemList);
            }
            if (item.AnswerList && item.AnswerList.length > 0) {
              var children = [];
              item.AnswerList.forEach((answer) => {
                if (answer.AnswerContent) {
                  children.push({
                    ProblemText: answer.AnswerContent,
                    ChildProblemList: answer.ChildProblemList,
                  });
                } else if (answer.ChildProblemList) {
                  children = children.concat(answer.ChildProblemList);
                }
              });
              item.children = item.children.concat(children);
            }
          };
          var formatNestedData = (data) => {
            data.forEach((item) => {
              formatData(item);
              if (item.children && item.children.length > 0) {
                formatNestedData(item.children);
              }
            });
          };
          formatNestedData(data);
          this.chartData = data;
          this.getMenuList(data);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
@import "~assets/css/zm-tree-org.css";
.answerDetail {
  ::v-deep .van-collapse-item__content {
    padding: 0px;
    color: #000;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  .zm-tree-org {
    margin-top:10px;
    height: 80vh;
    background: transparent;
    ::v-deep .zm-tree-handle {
      display: none !important;
    }
  }
}
</style>
